import { Candy, Users, Laugh, Wand2, Sparkles, Gift, Music, GraduationCap, Smile } from 'lucide-react';
import { PRICING } from './pricing';

const S = PRICING.spectacles;
const showPrice = `Tous nos spectacles : à partir de ${S.minimum} €, hors frais de déplacement. Devis sous 24 h.`;

export const SHOWS = {
  'spectacle-bonbon-magic': {
    name: 'Bonbon Magic',
    poster: '/images/bonbon-magic-affiche.webp',
    posterAlt: 'Affiche du spectacle de magie Bonbon Magic du Clown Magicien',
    badge: 'Nouveauté 2027',
    title: 'Bonbon Magic : Nouveau Spectacle de Magie 2027 | Bretagne',
    description: 'Bonbon Magic, le nouveau spectacle de magie interactif 2027 du Clown Magicien : les bonbons prennent vie ! Écoles, mairies, CSE, anniversaires en Bretagne. Devis 24h.',
    keywords: 'spectacle de magie bonbons, Bonbon Magic, nouveau spectacle magie 2027, spectacle interactif enfants Bretagne',
    subtitle: 'Le spectacle de magie où les bonbons prennent vie',
    intro: 'Le nouveau spectacle interactif du Clown Magicien. Des bonbons, des rires, et surtout... vous ! Un moment de magie gourmande à partager en famille, partout en Bretagne.',
    facts: [],
    highlights: [
      { icon: Candy, title: 'Les bonbons prennent vie', text: 'Des tours de magie où les bonbons apparaissent, se transforment et voyagent sous les yeux du public.' },
      { icon: Users, title: 'Un spectacle interactif', text: 'Les enfants ne regardent pas seulement : ils montent sur scène et deviennent les assistants du magicien.' },
      { icon: Laugh, title: 'Des rires en continu', text: 'L\'humour du clown magicien rythme chaque tour, pour les petits comme pour les parents.' },
    ],
    occasions: ['Écoles et kermesses', 'Mairies et comités des fêtes', 'Arbres de Noël CE / CSE', 'Campings et villages vacances', 'Anniversaires et fêtes de famille', 'Médiathèques et centres de loisirs'],
    price: showPrice,
    ctaTitle: 'Réservez Bonbon Magic pour 2027',
  },
  'spectacle-clown-guigui-fait-son-cirque': {
    name: 'Le Clown Guigui fait son cirque',
    poster: '/images/guigui-fait-son-cirque-affiche.webp',
    posterAlt: 'Affiche du spectacle de magie et cirque Le Clown Guigui fait son cirque',
    badge: 'Spectacle de magie et cirque',
    title: 'Le Clown Guigui fait son cirque | Spectacle Magie Enfants',
    description: 'Le Clown Guigui fait son cirque : spectacle de magie comique et de jonglerie de 45 min pour les 3-10 ans. Écoles, arbres de Noël, mairies en Finistère et Morbihan.',
    keywords: 'spectacle clown magie enfants, Clown Guigui, spectacle cirque école Finistère, spectacle magie Morbihan',
    subtitle: 'Magie comique, jonglerie et rires pour les 3-10 ans',
    intro: 'Le Clown Guigui entre en piste avec ses tours de magie comiques et sa jonglerie. Les enfants participent du début à la fin : un spectacle pensé pour faire rire et émerveiller les 3-10 ans, en Finistère et dans le Morbihan.',
    facts: ['45 minutes', 'Enfants de 3 à 10 ans', 'Salle ou extérieur'],
    highlights: [
      { icon: Wand2, title: 'Magie comique', text: 'Des tours visuels et drôles, compréhensibles même par les plus petits.' },
      { icon: Sparkles, title: 'Jonglerie et cirque', text: 'L\'univers du cirque s\'invite dans votre salle, avec jonglerie et numéros de clown.' },
      { icon: Users, title: 'Participation active', text: 'Les enfants sont invités à aider le clown : chacun repart avec un souvenir de la fête.' },
    ],
    occasions: ['Écoles maternelles et primaires', 'Arbres de Noël CE / CSE', 'Mairies et comités des fêtes', 'Centres de loisirs', 'Campings et villages vacances', 'Anniversaires'],
    price: showPrice,
    ctaTitle: 'Réservez le Clown Guigui',
  },
  'spectacle-comment-devenir-magicien': {
    name: 'Comment devenir magicien',
    poster: '/images/comment-devenir-magicien-affiche.webp',
    posterAlt: 'Affiche du spectacle interactif Comment devenir magicien',
    badge: 'Spectacle interactif',
    title: 'Comment devenir magicien | Spectacle Magie Interactif Enfants',
    description: 'Comment devenir magicien : spectacle interactif de 50 min où les enfants de 5 à 12 ans apprennent des tours de magie. Écoles, centres de loisirs en Finistère et Morbihan.',
    keywords: 'spectacle magie interactif enfants, apprendre la magie enfants, spectacle école magie Finistère, magicien école Morbihan',
    subtitle: 'Le spectacle où les enfants apprennent de vrais tours de magie',
    intro: 'Dans ce spectacle, le magicien ne garde pas tous ses secrets : les enfants découvrent et apprennent des tours de magie qu\'ils pourront refaire à la maison. Un moment ludique et participatif pour les 5-12 ans.',
    facts: ['50 minutes', 'Enfants de 5 à 12 ans', 'Idéal en école'],
    highlights: [
      { icon: GraduationCap, title: 'Une vraie école de magie', text: 'Le spectacle est construit comme un premier cours de magie, avec des tours accessibles à tous.' },
      { icon: Users, title: 'Magie participative', text: 'Les enfants montent sur scène, essaient les tours et deviennent magiciens à leur tour.' },
      { icon: Smile, title: 'Des souvenirs à refaire', text: 'Les tours appris pendant le spectacle peuvent être montrés aux parents le soir même.' },
    ],
    occasions: ['Écoles primaires', 'Centres de loisirs', 'Médiathèques', 'Mairies et comités des fêtes', 'Arbres de Noël CE / CSE', 'Anniversaires des plus grands'],
    price: showPrice,
    ctaTitle: 'Réservez « Comment devenir magicien »',
  },
  'spectacle-martin-le-lutin': {
    name: 'Martin le Lutin',
    poster: '/images/martin-le-lutin-affiche.webp',
    posterAlt: 'Affiche du spectacle de Noël Martin le Lutin',
    badge: 'Spectacle de Noël',
    title: 'Martin le Lutin | Spectacle de Noël Magie Arbre de Noël',
    description: 'Martin le Lutin : spectacle de Noël féérique de 45 min, magie et chants de Noël pour les 3-10 ans. Arbres de Noël CSE, mairies, écoles en Finistère et Morbihan.',
    keywords: 'spectacle de Noël enfants, Martin le Lutin, spectacle arbre de Noël CSE Finistère, spectacle Noël Morbihan',
    subtitle: 'La magie de Noël racontée par un lutin',
    intro: 'Martin le Lutin apporte la magie de Noël dans votre salle : tours de magie, chants de Noël et ambiance féérique. Le spectacle idéal pour un arbre de Noël d\'entreprise, de mairie ou d\'école.',
    facts: ['45 minutes', 'Enfants de 3 à 10 ans', 'Novembre et décembre'],
    highlights: [
      { icon: Gift, title: 'Ambiance Noël féérique', text: 'Costume, décor et histoire de lutin : les enfants plongent dans l\'univers de Noël.' },
      { icon: Music, title: 'Magie et chants de Noël', text: 'Les tours de magie alternent avec des chants que les enfants reprennent en chœur.' },
      { icon: Users, title: 'Pensé pour les arbres de Noël', text: 'Le format s\'adapte à une salle de CSE, de mairie ou à un préau d\'école.' },
    ],
    occasions: ['Arbres de Noël CE / CSE', 'Mairies et comités des fêtes', 'Écoles maternelles et primaires', 'Marchés de Noël', 'Centres de loisirs', 'Associations'],
    price: showPrice,
    ctaTitle: 'Réservez Martin le Lutin pour Noël',
  },
};

export const SHOW_SLUGS = Object.keys(SHOWS);
